import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import {
  CreateRecipeFR,
  DescriptionChanged,
  EndDateChanged,
  EndDateCleared,
  InactiveChanged,
  NameChanged,
  PointExpirationTypeChanged,
  PointExpirationValueChanged,
  PointsChanged,
  PointSourcesSuccess,
  RemarkChanged,
  SchemaChanged,
  StartDateChanged,
  StartDateCleared,
  SubmitDataFR,
  UpdateRecipeFR,
} from '../actions/registration-points.actions';
import { CloseSideNav, EditRecipe } from '../actions/search.actions';
import { RegistrationPointsCreateUpdateState } from '../models/registration-points.model';

const initialState: RegistrationPointsCreateUpdateState = {
  isUpdate: false,
  recipeType: 'FULL_REGISTRATION_POINTS',
  recipeDisplayName: '',
  showRecipeNameDuplicateMessage: false,
  recipeImagePath: 'assets/images/recipes/full_registration.png',
  selectedSchema: '',
  pointSources: [],
  selectedPointSourceId: 0,
  selectedPointSourceName: 'Registration',
  selectedPoints: null,
  selectedRemark: '',
  pointExpirationType: 'DAYS',
  pointExpirationValue: null,
  startDate: '',
  endDate: '',
  inactive: false,
  description: '',
  submit: false,
};

export const RegistrationPointsCreateUpdateReducer = createReducer(
  initialState,
  on(EditRecipe, (state, { row }) => {
    if (row.recipeType === state.recipeType) {
      return {
        ...state,
        isUpdate: true,
        recipeDisplayName: row.recipeDisplayName || null,
        selectedSchema: row.loyaltySchemaCode || null,
        selectedPoints: row.pointsToReward || null,
        startDate: row.startDate || null,
        endDate: row.endDate || null,
        selectedPointSourceId: row.loyaltyPointSourceId,
        pointExpirationType: row.pointExpirationType,
        pointExpirationValue: row.pointExpirationValue,
        selectedRemark: row.remark,
        inactive: row.deleteFlag ? true : false,
        description: row.description,
      };
    }
    return state;
  }),
  on(NameChanged, (state, { recipeDisplayName }) => ({
    ...state,
    recipeDisplayName,
  })),
  on(SchemaChanged, (state, { selectedSchema }) => ({
    ...state,
    selectedSchema,
  })),
  on(PointSourcesSuccess, (state, { pointSources }) => {
    const registrationSource = pointSources.find(
      (source) =>
        source.loyaltyPointSourceDescription === 'system.tableloyaltypointsource.registration',
    );
    const defaultId = registrationSource ? registrationSource.loyaltyPointSourceId : 0;

    return {
      ...state,
      pointSources: pointSources,
      selectedPointSourceId: defaultId,
    };
  }),
  on(RemarkChanged, (state, { selectedRemark }) => ({
    ...state,
    selectedRemark,
  })),
  on(PointExpirationTypeChanged, (state, { pointExpirationType }) => ({
    ...state,
    pointExpirationType,
  })),
  on(PointExpirationValueChanged, (state, { pointExpirationValue }) => ({
    ...state,
    pointExpirationValue,
  })),
  on(DescriptionChanged, (state, { description }) => ({
    ...state,
    description,
  })),
  on(StartDateChanged, (state, { startDate }) => ({
    ...state,
    startDate,
  })),
  on(StartDateCleared, (state) => ({
    ...state,
    startDate: '',
  })),
  on(EndDateChanged, (state, { endDate }) => ({
    ...state,
    endDate,
  })),
  on(EndDateCleared, (state) => ({
    ...state,
    endDate: '',
  })),
  on(PointsChanged, (state, { selectedPoints }) => ({
    ...state,
    selectedPoints,
  })),
  on(InactiveChanged, (state, { inactive }) => ({
    ...state,
    inactive,
  })),
  on(CreateRecipeFR, UpdateRecipeFR, (state) => ({
    ...state,
    submit: true,
  })),
  on(ActiveComponentChanged, CloseSideNav, () => initialState),
  on(SubmitDataFR, (state) => ({
    ...state,
    submit: true,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
